module.exports = __webpack_public_path__ + "static/media/Hayes Lee.58ee53b6.png";